<template>
    <el-input type="password" clearable :placeholder="placeholder" :value="value" @input="oninput" autocomplete="off">
        <el-button v-if="mysydjs" slot="append" @click="on读卡()">读卡</el-button>
    </el-input>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: {
        placeholder: {
            type: String,
            default: '请刷卡',
        },
        value: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            最后输入时间: 0,
            刷卡内容: '',
            定时器: 0,
        }
    },
    computed: {
        ...mapState(['IC卡密码']),
        mysydjs() {
            return window.sydjs;
        },
    },
    methods: {
        oninput(v) {
            if (!v) {
                this.$emit("input", v);
                return;
            }

            var 输入字符 = v.toString().substr(v.length - 1, 1);
            if (new Date().getTime() - this.最后输入时间 > 50) {
                this.刷卡内容 = '';
                this.$emit("input", this.刷卡内容);
            }
            this.最后输入时间 = new Date().getTime();
            this.刷卡内容 += 输入字符.toString();

            clearTimeout(this.定时器);
            this.定时器 = setTimeout(() => {
                if (this.刷卡内容.length > 3) this.$emit("input", this.刷卡内容);
            }, 100);
        },
        async on读卡() {
            try {
                if (!this.IC卡密码) await this.获取IC卡密码();
                let data = await window.sydjs.get0(this.IC卡密码);
                this.$emit("input", data);
                this.$emit("readcard", data);
            } catch (error) {
                this.$Alert(error);
            }
        },
        ...mapActions(['获取IC卡密码']),
    }
}
</script>

<style lang="scss" scoped>
</style>